import { render, staticRenderFns } from "./GdprCompliance.vue?vue&type=template&id=33fa9bf6&scoped=true&"
import script from "./GdprCompliance.vue?vue&type=script&lang=js&"
export * from "./GdprCompliance.vue?vue&type=script&lang=js&"
import style0 from "./GdprCompliance.vue?vue&type=style&index=0&id=33fa9bf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fa9bf6",
  null
  
)

export default component.exports